import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { TitleStrategy, provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import {
  TB_BFF_AUTH_REDIRECT_ENABLED,
  TB_FAVORITES_SERVICE,
  TB_MASKING_PREFERENCE,
  StepUpService,
  tbErrorInterceptor,
} from '@toybank/ui';
import { routes } from './app.routes';
import { TranslatedTitleStrategy } from './i18n/translated-title.strategy';
import { debugHttpInterceptor } from './debug/debug-http.interceptor';
import { provideAppTransloco } from './i18n/transloco.config';
import { FavoritesService } from './favorites.service';
import { AccountNumberMaskingService } from './account-number-masking.service';
import { DebugStepUpService } from './debug/debug-step-up.service';

// DEBUG / SANDBOX config: only this variant wires the debug HTTP logger into the stack.
// User selection is a real BFF cookie session via /bff/debug/login. angular.json swaps this
// file in for `app.config.ts` via a fileReplacement on the `debug` and `sandbox` configurations.
// It is never part of the production/bff bundle. See FE-3.
export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      // onSameUrlNavigation:'reload' makes router.navigate(['/home']) remount the outlet
      // component even when the current URL is already /home. Required for the in-place
      // persona-switch refresh: HomeDashboardComponent.ngOnInit() re-runs on every persona
      // hop, reloading the persona-scoped dashboard config + favorites + approvals/activity.
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
    ),
    // Localised document titles (walkabout 2026-09-28: German sessions kept English tab titles).
    { provide: TitleStrategy, useExisting: TranslatedTitleStrategy },
    ...provideAppTransloco(),
    provideHttpClient(
      withXsrfConfiguration({ cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' }),
      withInterceptors([debugHttpInterceptor, tbErrorInterceptor]),
    ),
    { provide: TB_FAVORITES_SERVICE, useExisting: FavoritesService },
    { provide: TB_MASKING_PREFERENCE, useExisting: AccountNumberMaskingService },
    { provide: TB_BFF_AUTH_REDIRECT_ENABLED, useValue: false },
    { provide: StepUpService, useClass: DebugStepUpService },
  ],
};
